import React from 'react';
import { Row, Col, Card } from 'antd';
import PedidosNovos from '../components/Pedidos_Novos';
import PedidosProducao from '../components/Pedidos_Producao';
import PedidosEntrega from '../components/Pedidos_Entrega';

const Service = () => {
  return (
    <div className="content-wrapper">
      <h2 style={{ textAlign: 'center', marginBottom: '30px', fontSize: '24px' }}>
        Painel de Atendimento
      </h2>

      <Row gutter={[12, 12]} justify="center">
          <Col xs={24} sm={24} md={8}>
            <Card
            style={{ borderRadius: '12px', minHeight: '400px', boxShadow: '0 4px 12px rgba(0,0,0,0.1)' }}
            styles={{ body: { padding: '16px', maxHeight: '500px', overflowY: 'auto' } }} //  Correção
          >
              <PedidosNovos />
            </Card>
          </Col>
          <Col xs={24} sm={24} md={8}>
            <Card
            style={{ borderRadius: '12px', minHeight: '400px', boxShadow: '0 4px 12px rgba(0,0,0,0.1)' }}
            styles={{ body: { padding: '16px', maxHeight: '500px', overflowY: 'auto' } }} //  Correção
          >
              <PedidosProducao />
            </Card>
          </Col>
          <Col xs={24} sm={24} md={8}>
            <Card
            style={{ borderRadius: '12px', minHeight: '400px', boxShadow: '0 4px 12px rgba(0,0,0,0.1)' }}
            styles={{ body: { padding: '16px', maxHeight: '500px', overflowY: 'auto' } }} //  Correção
          >
              <PedidosEntrega />
            </Card>
          </Col>
        </Row>
        
    </div>
  );
};

export default Service;
